import { render, staticRenderFns } from "./dust-db.component.vue?vue&type=template&id=65f75a82"
import script from "./dust-db.component.ts?vue&type=script&lang=ts&external"
export * from "./dust-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f75a82')) {
      api.createRecord('65f75a82', component.options)
    } else {
      api.reload('65f75a82', component.options)
    }
    module.hot.accept("./dust-db.component.vue?vue&type=template&id=65f75a82", function () {
      api.rerender('65f75a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/dust-db/dust-db.component.vue"
export default component.exports